<template>
  <div class="project-page">
    <ProjectHero :project="project" />
    <FeatureGrid :features="project.features" :color="project.color" subtitle="以 Kotlin 扩展方法为核心，将日常高频操作压缩到一行代码" />
    <CodeSection
      :code-blocks="project.codeBlocks"
      :gradle-block="project.gradleBlock"
      :maven-block="project.mavenBlock"
      subtitle="从初始化到 RecyclerView、防抖点击，一行代码完成常用操作"
    />

    <!-- CTA -->
    <section class="section" style="padding-top:0">
      <div class="container">
        <div class="proj-cta-box" data-aos="fade-up">
          <div>
            <h3 class="proj-cta-title">想看完整源码与文档？</h3>
            <p class="proj-cta-desc">前往 GitHub 查看完整源码、Wiki、Issue 与 Release 历史。</p>
          </div>
          <a :href="project.repo" target="_blank" rel="noopener" class="btn btn-primary">
            <i class="fa-brands fa-github"></i> 前往 GitHub
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { projects } from '@/data/projects.js'
import ProjectHero from '@/components/ProjectHero.vue'
import FeatureGrid from '@/components/FeatureGrid.vue'
import CodeSection from '@/components/CodeSection.vue'

const project = projects.kotlinx
</script>

<style scoped>
.proj-cta-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: 16px;
  padding: 36px 40px;
}
.proj-cta-title {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 6px;
}
.proj-cta-desc { color: var(--text-muted); }
</style>
